import React, { FC, ReactNode, useEffect } from "react";
import styles from "./snackbar.module.scss";
import { WithPortal } from "../withPortal/WithPortal";
import { useEsc } from "../../hooks/useEsc";
import { ReactComponent as ClearIcon } from "./assets/clear.svg";
import classNames from "classnames";
import {IconButton} from "../../ui/iconButton/IconButton";

type Props = {
  children: ReactNode;
  onClose: () => void;
  isOpen: boolean;
  autoHideDuration?: number;
  className?: "error" | "success" | "warning";
};

export const Snackbar: FC<Props> = ({
  className,
  children,
  onClose,
  isOpen,
  autoHideDuration = 2000,
}) => {
  useEsc(onClose);

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, autoHideDuration);

    return () => clearTimeout(timer);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <WithPortal>
      <div
        className={classNames(
          styles.snackbar,
          { [styles.error]: className === "error" },
          { [styles.success]: className === "success" },
          { [styles.warning]: className === "warning" }
        )}
        role="dialog"
      >
        <div className={styles.content}>{children}</div>
        <IconButton onClick={onClose}>
          <ClearIcon />
        </IconButton>
      </div>
    </WithPortal>
  );
};
